import React from 'react'
import { DragObjectWithType, useDrop } from 'react-dnd'
import { DragObjectTypes } from '../../dragObjects'
import clsx from 'clsx'
import styles from './FreeCell.module.css'

export interface FreeCellProps<T> {
    row: number
    col: number
    suggest?: boolean
    onPlace: (x: { tile: T }) => any
}

export default function FreeCell<T extends DragObjectWithType>(props: FreeCellProps<T>) {
    const [{ isOver }, drop] = useDrop<T, {}, { isOver: boolean }>({
        accept: DragObjectTypes.Tile,
        drop: tile => props.onPlace({ tile }),
        collect: monitor => ({
            isOver: !!monitor.isOver(),
        }),
    })

    return (
        <div
            ref={drop}
            className={clsx(styles.freeCell, {
                [styles.suggested]: !!props.suggest,
                [styles.highlighted]: isOver,
            })}
        />
    )
}